import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import {
    fetchReportPagination,
    fetchHistoryStatus,
    fetchExtent,
    fetchStatusReport,
    fetchStatisticReport,
    fetchReportById,
    updateReportStatus,
    updateReportLinhVuc,
    fetchAssignableUsers,
    assignReportNguoiXuLy,
    fetchPhanAnhTheoThang,
    createNewReport
} from '../features/reports/reportThunk';
import {
    selectReports,
    selectCurrentReport,
    selectHistoryStatus,
    selectExtent,
    selectStatusReport,
    selectReportLoading,
    selectReportError,
    selectReportPagination,
    selectReportFilters
    ,selectReportStatistic
    ,selectPhanAnhTheoThang
    ,selectPhanAnhTheoThangLoading
} from '../features/reports/reportSelectors';
import {
    clearError,
    setCurrentReport,
    clearCurrentReport,
    setFilters,
    resetFilters
} from '../features/reports/reportSlice';

export const useReports = ({ autoFetch = false, filters = {} } = {}) => {
    const dispatch = useDispatch();

    const reports = useSelector(selectReports);
    const currentReport = useSelector(selectCurrentReport);
    const historyStatus = useSelector(selectHistoryStatus);
    const extent = useSelector(selectExtent);
    const statusReport = useSelector(selectStatusReport);
    const loading = useSelector(selectReportLoading);
    const error = useSelector(selectReportError);
    const pagination = useSelector(selectReportPagination);
    const currentFilters = useSelector(selectReportFilters);
    const statistic = useSelector(selectReportStatistic);
    const phanAnhTheoThang = useSelector(selectPhanAnhTheoThang);
    const phanAnhTheoThangLoading = useSelector(selectPhanAnhTheoThangLoading);

    const loadReports = useCallback((params = {}) => {
        return dispatch(fetchReportPagination(params)).unwrap();
    }, [dispatch]);

    const loadReportById = useCallback((reportId) => {
        return dispatch(fetchReportById(reportId)).unwrap();
    }, [dispatch]);

    const loadHistoryStatus = useCallback((reportId) => {
        return dispatch(fetchHistoryStatus(reportId)).unwrap();
    }, [dispatch]);

    const loadExtent = useCallback(() => {
        if (extent && Object.keys(extent).length > 0) {
            return Promise.resolve(extent);
        }
        return dispatch(fetchExtent()).unwrap();
    }, [dispatch, extent]);

    const forceLoadExtent = useCallback(() => {
        return dispatch(fetchExtent()).unwrap();
    }, [dispatch]);

    const loadStatisticReport = useCallback((params = {}) => {
        return dispatch(fetchStatisticReport(params)).unwrap();
    }, [dispatch]);

    const loadStatusReport = useCallback(() => {
        if (statusReport && Object.keys(statusReport).length > 0) {
            return Promise.resolve(statusReport);
        }
        return dispatch(fetchStatusReport()).unwrap();
    }, [dispatch, statusReport]);

    const forceLoadStatusReport = useCallback(() => {
        return dispatch(fetchStatusReport()).unwrap();
    }, [dispatch]);

    const updateFilters = useCallback((newFilters) => {
        dispatch(setFilters(newFilters));
    }, [dispatch]);

    const clearFilters = useCallback(() => {
        dispatch(resetFilters());
    }, [dispatch]);

    const setSelectedReport = useCallback((report) => {
        dispatch(setCurrentReport(report));
    }, [dispatch]);

    const clearSelectedReport = useCallback(() => {
        dispatch(clearCurrentReport());
    }, [dispatch]);

    const clearReportError = useCallback(() => {
        dispatch(clearError());
    }, [dispatch]);

    const updateStatus = useCallback((reportId, statusData) => {
        return dispatch(updateReportStatus({ reportId, statusData })).unwrap();
    }, [dispatch]);

    const updateLinhVuc = useCallback((reportId, idLinhVucPhanAnh, lyDo) => {
        return dispatch(updateReportLinhVuc({ reportId, idLinhVucPhanAnh, lyDo })).unwrap();
    }, [dispatch]);

    const loadAssignableUsers = useCallback((reportId) => {
        return dispatch(fetchAssignableUsers(reportId)).unwrap();
    }, [dispatch]);

    const assignReport = useCallback((reportId, idNguoiXuLy, lyDo) => {
        return dispatch(assignReportNguoiXuLy({ reportId, idNguoiXuLy, lyDo })).unwrap();
    }, [dispatch]);

    const loadPhanAnhTheoThang = useCallback((params = {}) => {
        return dispatch(fetchPhanAnhTheoThang(params)).unwrap();
    }, [dispatch]);

    const createReport = useCallback((reportData) => {
        return dispatch(createNewReport(reportData)).unwrap();
    }, [dispatch]);

    return {
        reports,
        currentReport,
        historyStatus,
        extent,
        statusReport,
        loading,
        error,
        pagination,
        filters: currentFilters,

        loadReports,
        loadReportById,
        loadHistoryStatus,
        loadExtent,
        forceLoadExtent,
        loadStatusReport,
        forceLoadStatusReport,
        updateFilters,
        clearFilters,
        setSelectedReport,
        clearSelectedReport,
        clearError: clearReportError,
        updateStatus,
        updateLinhVuc,
        loadAssignableUsers,
        assignReport,
        statistic,
        loadStatisticReport,
        phanAnhTheoThang,
        phanAnhTheoThangLoading,
        loadPhanAnhTheoThang,
        createReport
    };
};
